export default $ => {

  // Primary navigation
  const menu = $('.cNavigation-Primary__StandardBar');
  const toggler = $('.cNavigation-Primary__Toggler');
  const languageDropdown = $('#cNavigation-Primary__LanguageSelector');
  const linksThatCloseTheSidebar = menu.find('a')
    .add(languageDropdown.find('a'))
    .not('[data-dropdown]')
    .not(toggler);

  toggler.on('click', function () {
    menu.toggleClass('uNavigationSidebar');
    $('body').toggleClass('uNavigationSidebar');
  });

  linksThatCloseTheSidebar.on('click', function () {
    languageDropdown.removeClass('uIsOpen');
    menu.removeClass('uNavigationSidebar');
    $('body').removeClass('uNavigationSidebar');
  });

  // Fix SVGs for IE
  if ($('body').hasClass('bInternetExplorer')) {
    $('svg').each(function () {
      const $svg = $(this);
      const sizes = $svg.attr('viewBox').split(' ');

      if (sizes.length > 2) {
        $svg.wrap(
          $('<div style="display:inline-block"></div>').width(sizes[2])
        );
      }
    });
  }

  // Initialize select2 for the elements with the data-select2 attribute
  // if the select is wrapped in a "eField--Select__Widget", then unwrap
  // it to prevent double styles on elements
  document.arrive('[data-select-widget]', {existing: true}, function () {
    const $select = $(this);

    if ($select.parent().hasClass('eField--Select__Widget')) {
      $select.siblings().filter('.eField--Select__Arrow').remove();
      $select.unwrap();
    }

    $select.select2({ width: '100%' });
  });
}



// WEBPACK FOOTER //
// ./assets/js/component/misc.js